import i18next from 'i18next';

i18next.addResources('es_CL', 'Coupons', {
  pagePath: '/cupones',
  pageTitle: 'Tus cupones disponibles | Papa Johns',
  pageDescription:
    'Revisa tus cupones activos y no te pierdas las mejores promociones. ¡Aprovecha los descuentos pensados especialmente para ti!',
  title: 'Cupones',
  availableCoupons: 'Disponibles',
  pastCoupons: 'Historial',
  discount: 'Descuento',
  minimumToRedeem: 'Compra mínima desde',
  categories: 'Aplica a',
  expiryDate: ' Válido hasta el',
  usedAt: 'Usado el',
  expiryAt: 'Expiró el',
  quantityRemaining: 'Usos restantes',
  emptyStateAction: 'Ir al inicio',
  emptyStateTitle: 'Aún no tienes cupones',
  emptyStateTitleHistory: 'Aún no hay cupones en tu historial',
  emptyStateMessage: '¡Mantente atento, pronto podría llegar uno para ti!',
  emptyStateMessageHistory: 'Aquí aparecerán los cupones que hayas usado o que hayan vencido.',
  copyCode: 'Copiar Código',
  sizes: 'tamaño'
});

i18next.addResources('pt_PT', 'Coupons', {
  path: '/cupons'
});
